import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { DynamicSectionMutationKeys } from '../../../keys'
import {
	UpdateDynamicSectionRequest,
	UpdateDynamicSectionResponse,
} from '../../../type'
import { updateDynamicSection } from '../../services'

interface UseMutationUpdateDynamicSectionProps {
	id: string
	payload: UpdateDynamicSectionRequest
}

export default function useMutationUpdateDynamicSection(
	props?: UseBaseMutationOptions<
		UpdateDynamicSectionResponse,
		UseMutationUpdateDynamicSectionProps
	>,
) {
	return useMutation({
		mutationKey: [DynamicSectionMutationKeys.UpdateDynamicSection],
		mutationFn: (params) => updateDynamicSection(params.id, params.payload),
		...props,
	})
}
